import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  inactivityDialogResolve: Function;
  private inactivityFlag = false;
  private _dialogInactivitySubject = new BehaviorSubject(false);

  constructor() {
  }

  isUserActive(): boolean {
    return !this.inactivityFlag;
  }

  setInactivityFlag(flag: boolean): void {
    this.inactivityFlag = flag;
  }

  getDialogInactivityObservable(): Observable<boolean> {
    return this._dialogInactivitySubject.asObservable();
  }

  initDialogInactivity(): void {
    this._dialogInactivitySubject.next(false);
  }

  openDialogInactivity(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.inactivityDialogResolve = resolve;
      this._dialogInactivitySubject.next(true);
    });
  }

  closeDialogInactivity(acceptFlag: boolean, executeResolve = true): void {
    this._dialogInactivitySubject.next(false);
    if (executeResolve) {
      this.inactivityDialogResolve(acceptFlag);
    }
  }
}
